module.exports = __webpack_public_path__ + "img/connected-icon.330f7f62.svg";